import { Component, Input } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreateEditWindowComponent } from './create-edit-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { User } from '@app/core/models';
import { ZonedDate } from "@progress/kendo-date-math";
import { environment } from '@environments/environment';
import * as moment from 'moment'


@Component({
  selector: 'edit-service-inventory',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="960" title="Recepción de Servicio" *ngIf="opened" (close)="onClose()">
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">        
          <div class="row">
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Fecha y hora de salida:"></kendo-label>
                  <p class="data-info k-color-info">{{intl.formatDate(this.form.value.output_date, "dd-MMM-yyyy HH:mm")}}</p>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Fecha y hora de entrada:"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-datepicker formControlName="entry_date" [format]="'dd-MMM-yyyy HH:mm'"></kendo-datepicker>
                  </kendo-textbox-container>
                  <div *ngIf="f.entry_date.invalid && (f.entry_date.dirty || f.entry_date.touched)">                  
                    <div *ngIf="f.entry_date.errors">
                      <kendo-formerror *ngIf="f.entry_date.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>
              </div>  
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Grúa:"></kendo-label>
                  <p class="data-info k-color-info">{{this.form.value.crane_name}}</p>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Estatus:"></kendo-label>
                  <dynamic-dropdownlist formControlName="id_service_status" [table]="'services_status'" [valueField]="'id'" [textField]="'name'" [showAll]="true" [extraFilter]="[{field: 'id', operator: 'in', value: '2,4'}]"></dynamic-dropdownlist>                                                 
              </div>              
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Operador:"></kendo-label>
                  <p class="data-info k-color-info">{{this.form.value.person_operator_name}}</p>
              </div>
              <div class="col-xs-6 col-sm-6 example-col" *ngIf="this.form.value.id_service_status == 2">
                  <kendo-label text="Forma de pago:"></kendo-label>
                  <dynamic-dropdownlist formControlName="id_payment_type" [table]="'payments_types'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>                                                 
              </div> 
              <div class="col-xs-6 col-sm-6 example-col" *ngIf="this.form.value.id_service_status == 4">
                  <kendo-label text="Cliente:"></kendo-label>
                  <dynamic-dropdownlist formControlName="id_customer" [table]="'customers'" [valueField]="'id'" [textField]="'name'" [showAll]="true" (selected)="customerSelected($event)"></dynamic-dropdownlist>                                                 
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  
              </div>     
              <div class="col-xs-6 col-sm-6 example-col" *ngIf="this.form.value.id_service_status == 2 || this.form.value.id_service_status == 4">
                  <kendo-label text="Costo:"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-numerictextbox formControlName="cost" [format]="'c2'" [min]="0" [autoCorrect]="true"></kendo-numerictextbox>
                  </kendo-textbox-container> 
                  <div *ngIf="f.cost.invalid && (f.cost.dirty || f.cost.touched)">                  
                    <div *ngIf="f.cost.errors">
                      <kendo-formerror *ngIf="f.cost.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div> 
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Núm. de factura:"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-textbox formControlName="invoice" [clearButton]="true" controlTrim></kendo-textbox>
                  </kendo-textbox-container> 
              </div>
              <div class="col-xs-12 col-sm-12 example-col">
                <kendo-label text="Observaciones:" [optional]="true"></kendo-label>
                <kendo-textbox-container>
                  <textarea kendoTextArea formControlName="observations" rows="3" controlTrim></textarea>
                </kendo-textbox-container>
              </div>              
          </div>
      </div>
    </form> 

    <div class="text-right">
        <button type="button" class="k-button" (click)="onCancel()">Cancelar</button>
        <button type="button" class="k-button k-primary ml-1" (click)="onSave()" [disabled]='!form.valid'>Guardar</button>
    </div>
       
  </kendo-window>      
  `,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }
    p.data-info {
      margin-bottom: 0px;
      // font-weight: bold;
      margin-top: 8px;
      padding: 6px;
      // background-color: #ecf0f1;
      border: 1px solid #ecf0f1;
      min-height: 30px;
    }
    p.right {
      text-align: right;
    }
    .k-numerictextbox .k-numeric-wrap .k-input {
      text-align: right;
    }
  `],
  providers: [ DatasourceService ]
})
export class EditServiceInventoryComponent extends CreateEditWindowComponent {

  @Input() table: string = 'services_inventories';

  protected touched = false;

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {

    super(authService, service, alertService);
    
  }

  //@Override
  public getObjectString(dataItem: any): string {

    return [
      `Id: '${dataItem.id}'`,      
      `Fecha de salida: '${this.intl.formatDate(dataItem.output_date, "yyyy-MM-dd HH:mm")}'`,
      `Grúa: '${dataItem.crane_name}'`,
      `Operador: '${dataItem.person_operator_name}'`,
    ].join('\n')

  };

  //@Override
  protected getFormGroup(user: User, dataItem?: any): FormGroup {    

    const tzOutputDate = ZonedDate.fromUTCDate((dataItem) ? new Date(dataItem.output_date) : new Date(), environment.timezone);
    const tzEntryDate = ZonedDate.fromUTCDate(new Date(dataItem.entry_date), environment.timezone);

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0), 
      'output_date': new FormControl((dataItem) ? new Date(tzOutputDate.toUTCString().replace('Dev', 'Dec')): new Date(), Validators.required), 
      'crane_name': new FormControl((dataItem) ? dataItem.crane_name: ""),
      'person_operator_name': new FormControl((dataItem) ? dataItem.person_operator_name: ""),
      'place': new FormControl((dataItem) ? dataItem.place: ""),  
      
      'entry_date': new FormControl((dataItem && dataItem.id_service_status == 2) ? new Date(tzEntryDate.toUTCString().replace('Dev', 'Dec')): new Date(), Validators.required),
      'id_payment_type': new FormControl(1, Validators.required),
      'id_service_status': new FormControl(2, Validators.required),
      'id_customer': new FormControl(1),
      'credit_days': new FormControl(0),
      'expiration_date': new FormControl(null),
      'cost': new FormControl(0),
      'invoice': new FormControl(""),
      'observations': new FormControl((dataItem) ? dataItem.observations: ""),      
    });    

  };

  // //@Override
  // protected getData(formGroup: FormGroup): Object {

  //   return Object.assign({}, formGroup.value, { 
  //     password: formGroup.value.pass1
  //   });

  // }; 

  //@Override
  public edit(dataItem: any, rowIndex: number = null): void {

    this.mode = 'EDIT';
    this.opened = true;
    this.form = this.getFormGroup(this.currentUser, dataItem);    
    // this.outputDateValueChange(this.form.value.output_date);    
  
  }  

  
  //@Override
  public delete(dataItem: any): void {
    
    this.mode = 'DELETE';
    this.opened = false;
    console.log(dataItem);

    this.alertService.confirm(`<p>¿Esta seguro que desea cancelar la recepción del sig. registro?</p> ${this.getObjectString(dataItem)}`, () => {

      this.onDelete(dataItem);

    });
    
  }

  //@Override
  protected getData(formGroup: FormGroup): Object {
    
    // console.log(formGroup);

    return Object.assign({}, { 
      id: formGroup.value.id,
      entry_date: (this.mode == 'EDIT') ? this.intl.formatDate(formGroup.value.entry_date, "yyyy-MM-dd HH:mm") : null,
      id_payment_type: (this.mode == 'EDIT' && formGroup.value.id_service_status == 2) ? formGroup.value.id_payment_type : null,
      cost: (this.mode == 'EDIT' && (formGroup.value.id_service_status == 2 || formGroup.value.id_service_status == 4)) ? formGroup.value.cost : null,
      id_service_status: (this.mode == 'EDIT') ? formGroup.value.id_service_status : 1,
      id_customer: (this.mode == 'EDIT' && formGroup.value.id_service_status == 4) ? formGroup.value.id_customer : null,
      credit_days: (this.mode == 'EDIT' && formGroup.value.id_service_status == 4) ? formGroup.value.credit_days : null,
      expiration_date: (this.mode == 'EDIT' && formGroup.value.id_service_status == 4) ? this.intl.formatDate(formGroup.value.expiration_date, "yyyy-MM-dd") : null,
      invoice: formGroup.value.invoice,
      observations: formGroup.value.observations,
    });

  };

  //@Override
  public onSave(): void {
    
    let data : any = this.getData(this.form);
    console.log('data', data)  
    
    // if (data.pass1 != data.pass2){
							
    //   this.alertService.showError('No coinciden las contraseñas.');
    //   return;
      
    // }
    
    this.service.updateRow(this.table, data) 
      .subscribe(
        (res) => {
          console.log("POST Request is successful: ", this.table, data);
          console.log("mode = " + this.mode);

          this.save.emit({mode: this.mode, dataItem: res.data[0]});
          this.opened = false;
        },
        (fail) => {        
          console.log("Error", fail);
          // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      ); 

  }

  //@Override
  public onDelete(dataItem: any): void {
    
    // console.log(dataItem);
    this.form = this.getFormGroup(this.currentUser, dataItem)
    let data : any = this.getData(this.form);

    data.id = dataItem.id;
    // console.log('data', data)  
    
    this.service.updateRow(this.table, data) 
      .subscribe(
        (res) => {
          console.log("POST Request is successful: ", this.table, data);
          console.log("mode = " + this.mode);

          this.save.emit({mode: this.mode, dataItem: res.data[0]});
          // this.opened = false;
        },
        (fail) => {        
          console.log("Error", fail);
          // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      );  

  }

  protected customerSelected(sel) : void {

    console.log('VALUE:' + sel.value);
    console.log(sel.item);

    var expiration_date = moment().add(sel.item.credit_days, 'days').format('YYYY-MM-DD');

    this.form.patchValue({
      credit_days: sel.item.credit_days,
      expiration_date: expiration_date
    });

  }

}
